export default __webpack_public_path__ + "static/media/brand-story-ikumi.2e3c8d82.png";